/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPdpRecommendGroup
// ====================================================

export interface GetPdpRecommendGroup_related_item_list_PdpRecommendCardGroup {}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpRecommendCardGroup {}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_main_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_sub_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_more_button {
  /**
   * 텍스트
   */
  text: string;
  /**
   * 딥링크 URL
   */
  link_url: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_discount_info {
  title: string | null;
  color: string | null;
  image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_managed_category_list {
  id: string;
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
  /**
   * 카테고리 키
   */
  key: string;
  /**
   * 카테고리 1차 또는 2차 또는 3차 또는 4차
   */
  depth: number;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency {
  /**
   * 통화 정보. Accept-Language 헤더로 들어온 값을 분석해서 이에 맞는 통화로 변환한다.
   */
  currency: PdpPaymentCurrency;
  /**
   * 소수점 자리수
   */
  decimal: number;
  /**
   * 소수점 올림한 금액
   */
  price_without_decimal: number;
  /**
   * 화면에 표시할 통화(원, $, yen)
   */
  display_currency: string;
  /**
   * 통화 앞에 오는지 여부
   */
  is_currency_prefix: boolean;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list {
  /**
   * 2024년 4월자 신규 상품 카드 여부(신규 상품 카드 대응 완료 후 제거되어야함)
   */
  is_plp_v2: boolean | null;
  /**
   * 광고 뱃지 여부
   */
  is_ad: boolean;
  /**
   * 컴포넌트 type
   */
  type: PdpComponentType;
  /**
   * 쇼핑몰 id
   */
  shop_id: string;
  /**
   * 쇼핑몰 이름
   */
  shop_name: string | null;
  /**
   * 쇼핑몰에서 부여한 고유 product_no
   */
  shop_product_no: string | null;
  position: number;
  /**
   * 원본 image_url
   */
  image_url: string | null;
  /**
   * 썸네일화 webp_image_url
   */
  webp_image_url: string | null;
  /**
   * 이미지 경량화(still) jpeg_image_url
   */
  jpeg_image_url: string | null;
  /**
   * 쇼핑몰 메인 도메인과 product_no
   * ex. crealfit$333
   * 사실상 사용 x
   */
  uuid: string | null;
  /**
   * 광고 1.0에서 bridge page 노출 여부
   * 사실상 사용 x
   */
  bridge: boolean | null;
  /**
   * 상품 클릭시 이동할 url 주소
   */
  product_url: string | null;
  /**
   * 상품 이름
   */
  title: string | null;
  /**
   * 상품 가격
   * final_price 생기면서 사용x
   */
  price: number | null;
  /**
   * 상품의 할인율
   */
  discount_rate: number | null;
  /**
   * 무료배송 여부
   */
  free_shipping: boolean | null;
  /**
   * goods_id, 쇼핑몰의 product_no 등이 사용되는데
   * 정확하게 사용하는곳 x
   */
  origin_id: string | null;
  /**
   * zpay 상품 여부
   */
  zpay: boolean | null;
  /**
   * 상품이 한줄에 몇개 표기할지
   */
  column_count: number | null;
  /**
   * 상품 카드에 숫자를 표기하기 위한 필드
   */
  ranking: number | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price: number;
  /**
   * 연동된 가격중 가장 높은 가격
   */
  max_price: number;
  /**
   * catalog_product_id
   */
  catalog_product_id: string | null;
  /**
   * 앱 내부에서 어떤 browser 로 PDP를 띄울지 여부
   */
  browsing_type: PdpBrowsingType;
  /**
   * log
   */
  log: string | null;
  /**
   * 광고 id
   */
  aid: string | null;
  /**
   * 이미지 비율
   */
  image_ratio: number | null;
  /**
   * 상품의 리뷰 갯수
   */
  review_count: number | null;
  /**
   * 찜하기 여부
   * 아직 사용x
   */
  bookmarked: boolean;
  /**
   * zonly 상품 여부
   */
  is_zonly: boolean;
  /**
   * 브랜드 상품 여부
   */
  is_brand: boolean;
  /**
   * 찜 상품 여부
   */
  is_saved_product: boolean;
  /**
   * Catalog 상품의 상태 (판매중, 품절)
   */
  sales_status: PdpSearchedProductSalesStatus | null;
  /**
   * 상품의 리뷰 갯수 (#,### 형태)
   */
  display_review_count: string | null;
  /**
   * 상품의 리뷰 점수
   */
  review_score: number | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_discount_info | null;
  /**
   * 뱃지 리스트
   */
  badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_badge_list[] | null;
  /**
   * 브랜드 네임 우측 뱃지 리스트
   */
  brand_name_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 상단 뱃지 리스트
   */
  thumbnail_nudge_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 하단 뱃지 리스트
   */
  thumbnail_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list[] | null;
  /**
   * 관리 카테고리 리스트
   */
  managed_category_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_managed_category_list[] | null;
  /**
   * 가로형 상품 카드용 신규 뱃지
   */
  metadata_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list[] | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price_with_currency: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel {
  /**
   * 상품 카드 컴포넌트 리스트
   */
  component_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel_component_list[];
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup {
  position: number;
  type: PdpComponentType;
  /**
   * 사용 목적 타입
   */
  group_type: string;
  /**
   * 광고 캐러셀 여부
   */
  is_ad: boolean;
  /**
   * 메인 타이틀
   */
  main_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_main_title;
  /**
   * 서브 타이틀
   */
  sub_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_sub_title | null;
  /**
   * 더보기 버튼
   */
  more_button: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_more_button | null;
  /**
   * 상품 캐로셀
   */
  goods_carousel: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup_goods_carousel;
}

export type GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order = GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpRecommendCardGroup | GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order_PdpGoodsGroup;

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpRecommendCardGroup {}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_main_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_sub_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_more_button {
  /**
   * 텍스트
   */
  text: string;
  /**
   * 딥링크 URL
   */
  link_url: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_discount_info {
  title: string | null;
  color: string | null;
  image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_managed_category_list {
  id: string;
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
  /**
   * 카테고리 키
   */
  key: string;
  /**
   * 카테고리 1차 또는 2차 또는 3차 또는 4차
   */
  depth: number;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency {
  /**
   * 통화 정보. Accept-Language 헤더로 들어온 값을 분석해서 이에 맞는 통화로 변환한다.
   */
  currency: PdpPaymentCurrency;
  /**
   * 소수점 자리수
   */
  decimal: number;
  /**
   * 소수점 올림한 금액
   */
  price_without_decimal: number;
  /**
   * 화면에 표시할 통화(원, $, yen)
   */
  display_currency: string;
  /**
   * 통화 앞에 오는지 여부
   */
  is_currency_prefix: boolean;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list {
  /**
   * 2024년 4월자 신규 상품 카드 여부(신규 상품 카드 대응 완료 후 제거되어야함)
   */
  is_plp_v2: boolean | null;
  /**
   * 광고 뱃지 여부
   */
  is_ad: boolean;
  /**
   * 컴포넌트 type
   */
  type: PdpComponentType;
  /**
   * 쇼핑몰 id
   */
  shop_id: string;
  /**
   * 쇼핑몰 이름
   */
  shop_name: string | null;
  /**
   * 쇼핑몰에서 부여한 고유 product_no
   */
  shop_product_no: string | null;
  position: number;
  /**
   * 원본 image_url
   */
  image_url: string | null;
  /**
   * 썸네일화 webp_image_url
   */
  webp_image_url: string | null;
  /**
   * 이미지 경량화(still) jpeg_image_url
   */
  jpeg_image_url: string | null;
  /**
   * 쇼핑몰 메인 도메인과 product_no
   * ex. crealfit$333
   * 사실상 사용 x
   */
  uuid: string | null;
  /**
   * 광고 1.0에서 bridge page 노출 여부
   * 사실상 사용 x
   */
  bridge: boolean | null;
  /**
   * 상품 클릭시 이동할 url 주소
   */
  product_url: string | null;
  /**
   * 상품 이름
   */
  title: string | null;
  /**
   * 상품 가격
   * final_price 생기면서 사용x
   */
  price: number | null;
  /**
   * 상품의 할인율
   */
  discount_rate: number | null;
  /**
   * 무료배송 여부
   */
  free_shipping: boolean | null;
  /**
   * goods_id, 쇼핑몰의 product_no 등이 사용되는데
   * 정확하게 사용하는곳 x
   */
  origin_id: string | null;
  /**
   * zpay 상품 여부
   */
  zpay: boolean | null;
  /**
   * 상품이 한줄에 몇개 표기할지
   */
  column_count: number | null;
  /**
   * 상품 카드에 숫자를 표기하기 위한 필드
   */
  ranking: number | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price: number;
  /**
   * 연동된 가격중 가장 높은 가격
   */
  max_price: number;
  /**
   * catalog_product_id
   */
  catalog_product_id: string | null;
  /**
   * 앱 내부에서 어떤 browser 로 PDP를 띄울지 여부
   */
  browsing_type: PdpBrowsingType;
  /**
   * log
   */
  log: string | null;
  /**
   * 광고 id
   */
  aid: string | null;
  /**
   * 이미지 비율
   */
  image_ratio: number | null;
  /**
   * 상품의 리뷰 갯수
   */
  review_count: number | null;
  /**
   * 찜하기 여부
   * 아직 사용x
   */
  bookmarked: boolean;
  /**
   * zonly 상품 여부
   */
  is_zonly: boolean;
  /**
   * 브랜드 상품 여부
   */
  is_brand: boolean;
  /**
   * 찜 상품 여부
   */
  is_saved_product: boolean;
  /**
   * Catalog 상품의 상태 (판매중, 품절)
   */
  sales_status: PdpSearchedProductSalesStatus | null;
  /**
   * 상품의 리뷰 갯수 (#,### 형태)
   */
  display_review_count: string | null;
  /**
   * 상품의 리뷰 점수
   */
  review_score: number | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_discount_info | null;
  /**
   * 뱃지 리스트
   */
  badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_badge_list[] | null;
  /**
   * 브랜드 네임 우측 뱃지 리스트
   */
  brand_name_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 상단 뱃지 리스트
   */
  thumbnail_nudge_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 하단 뱃지 리스트
   */
  thumbnail_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list[] | null;
  /**
   * 관리 카테고리 리스트
   */
  managed_category_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_managed_category_list[] | null;
  /**
   * 가로형 상품 카드용 신규 뱃지
   */
  metadata_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list[] | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price_with_currency: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel {
  /**
   * 상품 카드 컴포넌트 리스트
   */
  component_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel_component_list[];
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup {
  position: number;
  type: PdpComponentType;
  /**
   * 사용 목적 타입
   */
  group_type: string;
  /**
   * 광고 캐러셀 여부
   */
  is_ad: boolean;
  /**
   * 메인 타이틀
   */
  main_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_main_title;
  /**
   * 서브 타이틀
   */
  sub_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_sub_title | null;
  /**
   * 더보기 버튼
   */
  more_button: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_more_button | null;
  /**
   * 상품 캐로셀
   */
  goods_carousel: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup_goods_carousel;
}

export type GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi = GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpRecommendCardGroup | GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi_PdpGoodsGroup;

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpRecommendCardGroup {}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_main_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_sub_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_more_button {
  /**
   * 텍스트
   */
  text: string;
  /**
   * 딥링크 URL
   */
  link_url: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_discount_info {
  title: string | null;
  color: string | null;
  image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_managed_category_list {
  id: string;
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
  /**
   * 카테고리 키
   */
  key: string;
  /**
   * 카테고리 1차 또는 2차 또는 3차 또는 4차
   */
  depth: number;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency {
  /**
   * 통화 정보. Accept-Language 헤더로 들어온 값을 분석해서 이에 맞는 통화로 변환한다.
   */
  currency: PdpPaymentCurrency;
  /**
   * 소수점 자리수
   */
  decimal: number;
  /**
   * 소수점 올림한 금액
   */
  price_without_decimal: number;
  /**
   * 화면에 표시할 통화(원, $, yen)
   */
  display_currency: string;
  /**
   * 통화 앞에 오는지 여부
   */
  is_currency_prefix: boolean;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list {
  /**
   * 2024년 4월자 신규 상품 카드 여부(신규 상품 카드 대응 완료 후 제거되어야함)
   */
  is_plp_v2: boolean | null;
  /**
   * 광고 뱃지 여부
   */
  is_ad: boolean;
  /**
   * 컴포넌트 type
   */
  type: PdpComponentType;
  /**
   * 쇼핑몰 id
   */
  shop_id: string;
  /**
   * 쇼핑몰 이름
   */
  shop_name: string | null;
  /**
   * 쇼핑몰에서 부여한 고유 product_no
   */
  shop_product_no: string | null;
  position: number;
  /**
   * 원본 image_url
   */
  image_url: string | null;
  /**
   * 썸네일화 webp_image_url
   */
  webp_image_url: string | null;
  /**
   * 이미지 경량화(still) jpeg_image_url
   */
  jpeg_image_url: string | null;
  /**
   * 쇼핑몰 메인 도메인과 product_no
   * ex. crealfit$333
   * 사실상 사용 x
   */
  uuid: string | null;
  /**
   * 광고 1.0에서 bridge page 노출 여부
   * 사실상 사용 x
   */
  bridge: boolean | null;
  /**
   * 상품 클릭시 이동할 url 주소
   */
  product_url: string | null;
  /**
   * 상품 이름
   */
  title: string | null;
  /**
   * 상품 가격
   * final_price 생기면서 사용x
   */
  price: number | null;
  /**
   * 상품의 할인율
   */
  discount_rate: number | null;
  /**
   * 무료배송 여부
   */
  free_shipping: boolean | null;
  /**
   * goods_id, 쇼핑몰의 product_no 등이 사용되는데
   * 정확하게 사용하는곳 x
   */
  origin_id: string | null;
  /**
   * zpay 상품 여부
   */
  zpay: boolean | null;
  /**
   * 상품이 한줄에 몇개 표기할지
   */
  column_count: number | null;
  /**
   * 상품 카드에 숫자를 표기하기 위한 필드
   */
  ranking: number | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price: number;
  /**
   * 연동된 가격중 가장 높은 가격
   */
  max_price: number;
  /**
   * catalog_product_id
   */
  catalog_product_id: string | null;
  /**
   * 앱 내부에서 어떤 browser 로 PDP를 띄울지 여부
   */
  browsing_type: PdpBrowsingType;
  /**
   * log
   */
  log: string | null;
  /**
   * 광고 id
   */
  aid: string | null;
  /**
   * 이미지 비율
   */
  image_ratio: number | null;
  /**
   * 상품의 리뷰 갯수
   */
  review_count: number | null;
  /**
   * 찜하기 여부
   * 아직 사용x
   */
  bookmarked: boolean;
  /**
   * zonly 상품 여부
   */
  is_zonly: boolean;
  /**
   * 브랜드 상품 여부
   */
  is_brand: boolean;
  /**
   * 찜 상품 여부
   */
  is_saved_product: boolean;
  /**
   * Catalog 상품의 상태 (판매중, 품절)
   */
  sales_status: PdpSearchedProductSalesStatus | null;
  /**
   * 상품의 리뷰 갯수 (#,### 형태)
   */
  display_review_count: string | null;
  /**
   * 상품의 리뷰 점수
   */
  review_score: number | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_discount_info | null;
  /**
   * 뱃지 리스트
   */
  badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_badge_list[] | null;
  /**
   * 브랜드 네임 우측 뱃지 리스트
   */
  brand_name_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 상단 뱃지 리스트
   */
  thumbnail_nudge_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 하단 뱃지 리스트
   */
  thumbnail_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list[] | null;
  /**
   * 관리 카테고리 리스트
   */
  managed_category_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_managed_category_list[] | null;
  /**
   * 가로형 상품 카드용 신규 뱃지
   */
  metadata_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list[] | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price_with_currency: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel {
  /**
   * 상품 카드 컴포넌트 리스트
   */
  component_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel_component_list[];
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup {
  position: number;
  type: PdpComponentType;
  /**
   * 사용 목적 타입
   */
  group_type: string;
  /**
   * 광고 캐러셀 여부
   */
  is_ad: boolean;
  /**
   * 메인 타이틀
   */
  main_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_main_title;
  /**
   * 서브 타이틀
   */
  sub_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_sub_title | null;
  /**
   * 더보기 버튼
   */
  more_button: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_more_button | null;
  /**
   * 상품 캐로셀
   */
  goods_carousel: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup_goods_carousel;
}

export type GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area = GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpRecommendCardGroup | GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area_PdpGoodsGroup;

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpRecommendCardGroup {}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_main_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_sub_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_more_button {
  /**
   * 텍스트
   */
  text: string;
  /**
   * 딥링크 URL
   */
  link_url: string;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_discount_info {
  title: string | null;
  color: string | null;
  image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_managed_category_list {
  id: string;
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
  /**
   * 카테고리 키
   */
  key: string;
  /**
   * 카테고리 1차 또는 2차 또는 3차 또는 4차
   */
  depth: number;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency {
  /**
   * 통화 정보. Accept-Language 헤더로 들어온 값을 분석해서 이에 맞는 통화로 변환한다.
   */
  currency: PdpPaymentCurrency;
  /**
   * 소수점 자리수
   */
  decimal: number;
  /**
   * 소수점 올림한 금액
   */
  price_without_decimal: number;
  /**
   * 화면에 표시할 통화(원, $, yen)
   */
  display_currency: string;
  /**
   * 통화 앞에 오는지 여부
   */
  is_currency_prefix: boolean;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list {
  /**
   * 2024년 4월자 신규 상품 카드 여부(신규 상품 카드 대응 완료 후 제거되어야함)
   */
  is_plp_v2: boolean | null;
  /**
   * 광고 뱃지 여부
   */
  is_ad: boolean;
  /**
   * 컴포넌트 type
   */
  type: PdpComponentType;
  /**
   * 쇼핑몰 id
   */
  shop_id: string;
  /**
   * 쇼핑몰 이름
   */
  shop_name: string | null;
  /**
   * 쇼핑몰에서 부여한 고유 product_no
   */
  shop_product_no: string | null;
  position: number;
  /**
   * 원본 image_url
   */
  image_url: string | null;
  /**
   * 썸네일화 webp_image_url
   */
  webp_image_url: string | null;
  /**
   * 이미지 경량화(still) jpeg_image_url
   */
  jpeg_image_url: string | null;
  /**
   * 쇼핑몰 메인 도메인과 product_no
   * ex. crealfit$333
   * 사실상 사용 x
   */
  uuid: string | null;
  /**
   * 광고 1.0에서 bridge page 노출 여부
   * 사실상 사용 x
   */
  bridge: boolean | null;
  /**
   * 상품 클릭시 이동할 url 주소
   */
  product_url: string | null;
  /**
   * 상품 이름
   */
  title: string | null;
  /**
   * 상품 가격
   * final_price 생기면서 사용x
   */
  price: number | null;
  /**
   * 상품의 할인율
   */
  discount_rate: number | null;
  /**
   * 무료배송 여부
   */
  free_shipping: boolean | null;
  /**
   * goods_id, 쇼핑몰의 product_no 등이 사용되는데
   * 정확하게 사용하는곳 x
   */
  origin_id: string | null;
  /**
   * zpay 상품 여부
   */
  zpay: boolean | null;
  /**
   * 상품이 한줄에 몇개 표기할지
   */
  column_count: number | null;
  /**
   * 상품 카드에 숫자를 표기하기 위한 필드
   */
  ranking: number | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price: number;
  /**
   * 연동된 가격중 가장 높은 가격
   */
  max_price: number;
  /**
   * catalog_product_id
   */
  catalog_product_id: string | null;
  /**
   * 앱 내부에서 어떤 browser 로 PDP를 띄울지 여부
   */
  browsing_type: PdpBrowsingType;
  /**
   * log
   */
  log: string | null;
  /**
   * 광고 id
   */
  aid: string | null;
  /**
   * 이미지 비율
   */
  image_ratio: number | null;
  /**
   * 상품의 리뷰 갯수
   */
  review_count: number | null;
  /**
   * 찜하기 여부
   * 아직 사용x
   */
  bookmarked: boolean;
  /**
   * zonly 상품 여부
   */
  is_zonly: boolean;
  /**
   * 브랜드 상품 여부
   */
  is_brand: boolean;
  /**
   * 찜 상품 여부
   */
  is_saved_product: boolean;
  /**
   * Catalog 상품의 상태 (판매중, 품절)
   */
  sales_status: PdpSearchedProductSalesStatus | null;
  /**
   * 상품의 리뷰 갯수 (#,### 형태)
   */
  display_review_count: string | null;
  /**
   * 상품의 리뷰 점수
   */
  review_score: number | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_discount_info | null;
  /**
   * 뱃지 리스트
   */
  badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_badge_list[] | null;
  /**
   * 브랜드 네임 우측 뱃지 리스트
   */
  brand_name_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_brand_name_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 상단 뱃지 리스트
   */
  thumbnail_nudge_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 하단 뱃지 리스트
   */
  thumbnail_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list[] | null;
  /**
   * 관리 카테고리 리스트
   */
  managed_category_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_managed_category_list[] | null;
  /**
   * 가로형 상품 카드용 신규 뱃지
   */
  metadata_emblem_badge_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list[] | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price_with_currency: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list_final_price_with_currency;
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel {
  /**
   * 상품 카드 컴포넌트 리스트
   */
  component_list: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel_component_list[];
}

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup {
  position: number;
  type: PdpComponentType;
  /**
   * 사용 목적 타입
   */
  group_type: string;
  /**
   * 광고 캐러셀 여부
   */
  is_ad: boolean;
  /**
   * 메인 타이틀
   */
  main_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_main_title;
  /**
   * 서브 타이틀
   */
  sub_title: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_sub_title | null;
  /**
   * 더보기 버튼
   */
  more_button: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_more_button | null;
  /**
   * 상품 캐로셀
   */
  goods_carousel: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup_goods_carousel;
}

export type GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area = GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpRecommendCardGroup | GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area_PdpGoodsGroup;

export interface GetPdpRecommendGroup_related_item_list_PDPRecommendGroup {
  /**
   * PDP 첫 구매 상품 리스트
   */
  first_order: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_first_order[];
  /**
   * PDP 셀러 코디 상품 리스트
   */
  seller_coordi: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_seller_coordi[];
  /**
   * PDP 상단 추천 영역 리스트
   */
  top_area: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_top_area[];
  /**
   * PDP 하단 추천 영역 리스트
   */
  bottom_area: GetPdpRecommendGroup_related_item_list_PDPRecommendGroup_bottom_area[];
}

export type GetPdpRecommendGroup_related_item_list = GetPdpRecommendGroup_related_item_list_PdpRecommendCardGroup | GetPdpRecommendGroup_related_item_list_PDPRecommendGroup;

export interface GetPdpRecommendGroup {
  /**
   * 카탈로그 PDP 상단, 하단 영역 추천 상품
   */
  related_item_list: GetPdpRecommendGroup_related_item_list[];
}

export interface GetPdpRecommendGroupVariables {
  catalog_product_id: string;
  group_type_list?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PDPGoodsGroup
// ====================================================

export interface PDPGoodsGroup_main_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface PDPGoodsGroup_sub_title {
  /**
   * 텍스트
   */
  text: string;
}

export interface PDPGoodsGroup_more_button {
  /**
   * 텍스트
   */
  text: string;
  /**
   * 딥링크 URL
   */
  link_url: string;
}

export interface PDPGoodsGroup_goods_carousel_component_list_discount_info {
  title: string | null;
  color: string | null;
  image_url: string | null;
}

export interface PDPGoodsGroup_goods_carousel_component_list_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface PDPGoodsGroup_goods_carousel_component_list_brand_name_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface PDPGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface PDPGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
  type: string | null;
}

export interface PDPGoodsGroup_goods_carousel_component_list_managed_category_list {
  id: string;
  /**
   * category DB의 category id
   */
  category_id: number;
  /**
   * 카테고리 이름
   */
  value: string;
  /**
   * 카테고리 키
   */
  key: string;
  /**
   * 카테고리 1차 또는 2차 또는 3차 또는 4차
   */
  depth: number;
}

export interface PDPGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list {
  image_url: string;
  dark_image_url: string | null;
  small_image_url: string | null;
  small_dark_image_url: string | null;
}

export interface PDPGoodsGroup_goods_carousel_component_list_final_price_with_currency {
  /**
   * 통화 정보. Accept-Language 헤더로 들어온 값을 분석해서 이에 맞는 통화로 변환한다.
   */
  currency: PdpPaymentCurrency;
  /**
   * 소수점 자리수
   */
  decimal: number;
  /**
   * 소수점 올림한 금액
   */
  price_without_decimal: number;
  /**
   * 화면에 표시할 통화(원, $, yen)
   */
  display_currency: string;
  /**
   * 통화 앞에 오는지 여부
   */
  is_currency_prefix: boolean;
}

export interface PDPGoodsGroup_goods_carousel_component_list {
  /**
   * 2024년 4월자 신규 상품 카드 여부(신규 상품 카드 대응 완료 후 제거되어야함)
   */
  is_plp_v2: boolean | null;
  /**
   * 광고 뱃지 여부
   */
  is_ad: boolean;
  /**
   * 컴포넌트 type
   */
  type: PdpComponentType;
  /**
   * 쇼핑몰 id
   */
  shop_id: string;
  /**
   * 쇼핑몰 이름
   */
  shop_name: string | null;
  /**
   * 쇼핑몰에서 부여한 고유 product_no
   */
  shop_product_no: string | null;
  position: number;
  /**
   * 원본 image_url
   */
  image_url: string | null;
  /**
   * 썸네일화 webp_image_url
   */
  webp_image_url: string | null;
  /**
   * 이미지 경량화(still) jpeg_image_url
   */
  jpeg_image_url: string | null;
  /**
   * 쇼핑몰 메인 도메인과 product_no
   * ex. crealfit$333
   * 사실상 사용 x
   */
  uuid: string | null;
  /**
   * 광고 1.0에서 bridge page 노출 여부
   * 사실상 사용 x
   */
  bridge: boolean | null;
  /**
   * 상품 클릭시 이동할 url 주소
   */
  product_url: string | null;
  /**
   * 상품 이름
   */
  title: string | null;
  /**
   * 상품 가격
   * final_price 생기면서 사용x
   */
  price: number | null;
  /**
   * 상품의 할인율
   */
  discount_rate: number | null;
  /**
   * 무료배송 여부
   */
  free_shipping: boolean | null;
  /**
   * goods_id, 쇼핑몰의 product_no 등이 사용되는데
   * 정확하게 사용하는곳 x
   */
  origin_id: string | null;
  /**
   * zpay 상품 여부
   */
  zpay: boolean | null;
  /**
   * 상품이 한줄에 몇개 표기할지
   */
  column_count: number | null;
  /**
   * 상품 카드에 숫자를 표기하기 위한 필드
   */
  ranking: number | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price: number;
  /**
   * 연동된 가격중 가장 높은 가격
   */
  max_price: number;
  /**
   * catalog_product_id
   */
  catalog_product_id: string | null;
  /**
   * 앱 내부에서 어떤 browser 로 PDP를 띄울지 여부
   */
  browsing_type: PdpBrowsingType;
  /**
   * log
   */
  log: string | null;
  /**
   * 광고 id
   */
  aid: string | null;
  /**
   * 이미지 비율
   */
  image_ratio: number | null;
  /**
   * 상품의 리뷰 갯수
   */
  review_count: number | null;
  /**
   * 찜하기 여부
   * 아직 사용x
   */
  bookmarked: boolean;
  /**
   * zonly 상품 여부
   */
  is_zonly: boolean;
  /**
   * 브랜드 상품 여부
   */
  is_brand: boolean;
  /**
   * 찜 상품 여부
   */
  is_saved_product: boolean;
  /**
   * Catalog 상품의 상태 (판매중, 품절)
   */
  sales_status: PdpSearchedProductSalesStatus | null;
  /**
   * 상품의 리뷰 갯수 (#,### 형태)
   */
  display_review_count: string | null;
  /**
   * 상품의 리뷰 점수
   */
  review_score: number | null;
  /**
   * 할인가 표기 정보
   */
  discount_info: PDPGoodsGroup_goods_carousel_component_list_discount_info | null;
  /**
   * 뱃지 리스트
   */
  badge_list: PDPGoodsGroup_goods_carousel_component_list_badge_list[] | null;
  /**
   * 브랜드 네임 우측 뱃지 리스트
   */
  brand_name_badge_list: PDPGoodsGroup_goods_carousel_component_list_brand_name_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 상단 뱃지 리스트
   */
  thumbnail_nudge_badge_list: PDPGoodsGroup_goods_carousel_component_list_thumbnail_nudge_badge_list[] | null;
  /**
   * PLP 상품카드 이미지 좌 하단 뱃지 리스트
   */
  thumbnail_emblem_badge_list: PDPGoodsGroup_goods_carousel_component_list_thumbnail_emblem_badge_list[] | null;
  /**
   * 관리 카테고리 리스트
   */
  managed_category_list: PDPGoodsGroup_goods_carousel_component_list_managed_category_list[] | null;
  /**
   * 가로형 상품 카드용 신규 뱃지
   */
  metadata_emblem_badge_list: PDPGoodsGroup_goods_carousel_component_list_metadata_emblem_badge_list[] | null;
  /**
   * 모든 할인이 적용된 최종 가격
   */
  final_price_with_currency: PDPGoodsGroup_goods_carousel_component_list_final_price_with_currency;
}

export interface PDPGoodsGroup_goods_carousel {
  /**
   * 상품 카드 컴포넌트 리스트
   */
  component_list: PDPGoodsGroup_goods_carousel_component_list[];
}

export interface PDPGoodsGroup {
  position: number;
  type: PdpComponentType;
  /**
   * 사용 목적 타입
   */
  group_type: string;
  /**
   * 광고 캐러셀 여부
   */
  is_ad: boolean;
  /**
   * 메인 타이틀
   */
  main_title: PDPGoodsGroup_main_title;
  /**
   * 서브 타이틀
   */
  sub_title: PDPGoodsGroup_sub_title | null;
  /**
   * 더보기 버튼
   */
  more_button: PDPGoodsGroup_more_button | null;
  /**
   * 상품 캐로셀
   */
  goods_carousel: PDPGoodsGroup_goods_carousel;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PdpBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum PdpComponentType {
  PDP_BEAUTY_PRODUCT_SUMMARY = "PDP_BEAUTY_PRODUCT_SUMMARY",
  PDP_BENEFIT_CONTENT = "PDP_BENEFIT_CONTENT",
  PDP_CENTER_ALIGNED_TEXT_BANNER = "PDP_CENTER_ALIGNED_TEXT_BANNER",
  PDP_COLOR_CHIP = "PDP_COLOR_CHIP",
  PDP_COLOR_SWATCH_CAROUSEL = "PDP_COLOR_SWATCH_CAROUSEL",
  PDP_COMMON_TEXT_WITH_IMAGE = "PDP_COMMON_TEXT_WITH_IMAGE",
  PDP_DESCRIPTION_CONTENT = "PDP_DESCRIPTION_CONTENT",
  PDP_EPICK_GROUP = "PDP_EPICK_GROUP",
  PDP_ESTIMATED_LOWEST_PRICE_INFO = "PDP_ESTIMATED_LOWEST_PRICE_INFO",
  PDP_EXPANDABLE_EXPLANATION = "PDP_EXPANDABLE_EXPLANATION",
  PDP_FITTING_MODEL = "PDP_FITTING_MODEL",
  PDP_FULL_WIDTH_NOTICE_BANNER = "PDP_FULL_WIDTH_NOTICE_BANNER",
  PDP_HORIZONTAL_CARD_GROUP = "PDP_HORIZONTAL_CARD_GROUP",
  PDP_IMAGE_BANNER_GROUP = "PDP_IMAGE_BANNER_GROUP",
  PDP_LINE_WITH_MARGIN = "PDP_LINE_WITH_MARGIN",
  PDP_LIVE_BANNER = "PDP_LIVE_BANNER",
  PDP_MAX_REWARD_BENEFIT_INFO = "PDP_MAX_REWARD_BENEFIT_INFO",
  PDP_NORMAL_SHIPPING_GROUP = "PDP_NORMAL_SHIPPING_GROUP",
  PDP_PRICE_BENEFIT_SUMMARY = "PDP_PRICE_BENEFIT_SUMMARY",
  PDP_PRICE_GROUP = "PDP_PRICE_GROUP",
  PDP_PROMOTION_PARTICIPATE_CONDITION_INFO = "PDP_PROMOTION_PARTICIPATE_CONDITION_INFO",
  PDP_PROMOTION_PERIOD = "PDP_PROMOTION_PERIOD",
  PDP_PROMOTION_WINNER_ANNOUNCEMENT_INFO = "PDP_PROMOTION_WINNER_ANNOUNCEMENT_INFO",
  PDP_RECOMMEND_PRODUCT_HEADER = "PDP_RECOMMEND_PRODUCT_HEADER",
  PDP_REVIEW_GROUP = "PDP_REVIEW_GROUP",
  PDP_ROLLING_BANNER = "PDP_ROLLING_BANNER",
  PDP_SHOP_SUMMARY = "PDP_SHOP_SUMMARY",
  PDP_SIMPLE_NOTICE = "PDP_SIMPLE_NOTICE",
  PDP_SIMPLE_TEXT_BANNER = "PDP_SIMPLE_TEXT_BANNER",
  PDP_SINGLE_HORIZONTAL_CARD_GROUP = "PDP_SINGLE_HORIZONTAL_CARD_GROUP",
  PDP_SKELETON = "PDP_SKELETON",
  PDP_STYLE_REVIEW_GROUP = "PDP_STYLE_REVIEW_GROUP",
  PDP_TEXT_LINK = "PDP_TEXT_LINK",
  PDP_TITLE_WITH_PRODUCT_SUMMARY = "PDP_TITLE_WITH_PRODUCT_SUMMARY",
  PDP_VERTICAL_GROUP = "PDP_VERTICAL_GROUP",
  PDP_WEB_CONTENT = "PDP_WEB_CONTENT",
  PDP_WEB_DESCRIPTION = "PDP_WEB_DESCRIPTION",
  PDP_ZIGZAG_GIFT_PRODUCT_INFO = "PDP_ZIGZAG_GIFT_PRODUCT_INFO",
  PDP_ZIGZIN_SHIPPING_BANNER = "PDP_ZIGZIN_SHIPPING_BANNER",
  PDP_ZIGZIN_SHIPPING_GROUP = "PDP_ZIGZIN_SHIPPING_GROUP",
  UX_AD_BANNER_CARD = "UX_AD_BANNER_CARD",
  UX_AD_DISPLAY_BANNER_GROUP = "UX_AD_DISPLAY_BANNER_GROUP",
  UX_AD_DISPLAY_LARGE_BANNER = "UX_AD_DISPLAY_LARGE_BANNER",
  UX_AD_DISPLAY_MID_BANNER = "UX_AD_DISPLAY_MID_BANNER",
  UX_AD_DISPLAY_SMALL_BANNER = "UX_AD_DISPLAY_SMALL_BANNER",
  UX_AD_DISPLAY_X_LARGE_BANNER = "UX_AD_DISPLAY_X_LARGE_BANNER",
  UX_AD_DISPLAY_X_MID_BANNER = "UX_AD_DISPLAY_X_MID_BANNER",
  UX_BANNER_ITEM = "UX_BANNER_ITEM",
  UX_BANNER_LIST = "UX_BANNER_LIST",
  UX_BRAND_THEME_CONTENT = "UX_BRAND_THEME_CONTENT",
  UX_BUTTON = "UX_BUTTON",
  UX_CATEGORY = "UX_CATEGORY",
  UX_CHECK_BUTTON_AND_SORTING = "UX_CHECK_BUTTON_AND_SORTING",
  UX_CLP_CATEGORY = "UX_CLP_CATEGORY",
  UX_ENTRY_BANNER = "UX_ENTRY_BANNER",
  UX_FULL_WIDTH_IMAGE_BANNER_GROUP = "UX_FULL_WIDTH_IMAGE_BANNER_GROUP",
  UX_GOODS_CARD_ITEM = "UX_GOODS_CARD_ITEM",
  UX_GOODS_CARD_LIST = "UX_GOODS_CARD_LIST",
  UX_GOODS_CAROUSEL = "UX_GOODS_CAROUSEL",
  UX_GOODS_FILTER_LIST = "UX_GOODS_FILTER_LIST",
  UX_GOODS_GROUP = "UX_GOODS_GROUP",
  UX_IMAGE = "UX_IMAGE",
  UX_IMAGE_AND_TEXT_TITLE = "UX_IMAGE_AND_TEXT_TITLE",
  UX_IMAGE_BANNER_GROUP = "UX_IMAGE_BANNER_GROUP",
  UX_IMAGE_GOODS_CARD_ITEM = "UX_IMAGE_GOODS_CARD_ITEM",
  UX_LINE = "UX_LINE",
  UX_LINE_WITH_MARGIN = "UX_LINE_WITH_MARGIN",
  UX_MULTILINE_RANKING_CAROUSEL = "UX_MULTILINE_RANKING_CAROUSEL",
  UX_NO_RESULTS = "UX_NO_RESULTS",
  UX_PDP_RECOMMEND_CARD_GROUP = "UX_PDP_RECOMMEND_CARD_GROUP",
  UX_PDP_RECOMMEND_GROUP = "UX_PDP_RECOMMEND_GROUP",
  UX_QUICK_MENU = "UX_QUICK_MENU",
  UX_SEARCHED_SHOP_CAROUSEL = "UX_SEARCHED_SHOP_CAROUSEL",
  UX_SEGMENT_TAB = "UX_SEGMENT_TAB",
  UX_SELECTION_AND_SORTING = "UX_SELECTION_AND_SORTING",
  UX_SHOP_EXPANDABLE_LIST = "UX_SHOP_EXPANDABLE_LIST",
  UX_SHOP_GROUP = "UX_SHOP_GROUP",
  UX_SHOP_RANKING_CARD_ITEM = "UX_SHOP_RANKING_CARD_ITEM",
  UX_SMALL_TEXT_TITLE = "UX_SMALL_TEXT_TITLE",
  UX_SORTING = "UX_SORTING",
  UX_TEXT = "UX_TEXT",
  UX_TEXT_AND_MORE_BUTTON = "UX_TEXT_AND_MORE_BUTTON",
  UX_TEXT_AND_SORTING = "UX_TEXT_AND_SORTING",
  UX_TEXT_TITLE = "UX_TEXT_TITLE",
  UX_WEB_PAGE = "UX_WEB_PAGE",
  UX_ZONLY_ENTRY_BANNER = "UX_ZONLY_ENTRY_BANNER",
  UX_ZONLY_ENTRY_CARD = "UX_ZONLY_ENTRY_CARD",
  UX_ZONLY_ENTRY_GROUP = "UX_ZONLY_ENTRY_GROUP",
  UX_ZONLY_ENTRY_INFO = "UX_ZONLY_ENTRY_INFO",
}

export enum PdpPaymentCurrency {
  CAD = "CAD",
  JPY = "JPY",
  KRW = "KRW",
  USD = "USD",
}

export enum PdpSearchedProductSalesStatus {
  CLOSED = "CLOSED",
  ON_SALE = "ON_SALE",
  PREPARING = "PREPARING",
  SOLD_OUT = "SOLD_OUT",
  SUSPENDED = "SUSPENDED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
